function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { stringValue } from 'vega-util';
import { VL_SELECTION_RESOLVE } from '..';
import { isScaleChannel } from '../../../channel';
import * as log from '../../../log';
import { hasContinuousDomain } from '../../../scale';
import { isLayerModel } from '../../model';
var scaleBindings = {
  has: function has(selCmpt) {
    return selCmpt.type === 'interval' && selCmpt.resolve === 'global' && selCmpt.bind && selCmpt.bind === 'scales';
  },
  parse: function parse(model, selCmpt) {
    var bound = selCmpt.scales = [];

    var _iterator = _createForOfIteratorHelper(selCmpt.project.items),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var proj = _step.value;
        var channel = proj.channel;

        if (!isScaleChannel(channel)) {
          continue;
        }

        var scale = model.getScaleComponent(channel);
        var scaleType = scale ? scale.get('type') : undefined;

        if (!scale || !hasContinuousDomain(scaleType)) {
          log.warn(log.message.SCALE_BINDINGS_CONTINUOUS);
          continue;
        }

        var extent = {
          selection: selCmpt.name,
          field: proj.field
        };
        scale.set('selectionExtent', extent, true);
        bound.push(proj);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    var bound = selCmpt.scales.filter(function (proj) {
      return signals.filter(function (s) {
        return s.name === proj.signals.data;
      }).length === 0;
    }); // Top-level signals are only needed for multiview displays and if this
    // view's top-level signals haven't already been generated.

    if (!model.parent || isTopLevelLayer(model) || bound.length === 0) {
      return signals;
    } // vlSelectionResolve does not account for the behavior of bound scales in
    // multiview displays. Each unit view adds a tuple to the store, but the
    // state of the selection is the unit selection most recently updated. This
    // state is captured by the top-level signals that we insert and "push
    // outer" to from within the units. We need to reassemble this state into
    // the top-level named signal, except no single selCmpt has a global view.


    var namedSg = signals.filter(function (s) {
      return s.name === selCmpt.name;
    })[0];
    var update = namedSg.update;

    if (update.indexOf(VL_SELECTION_RESOLVE) >= 0) {
      namedSg.update = "{".concat(bound.map(function (proj) {
        return "".concat(stringValue(proj.field), ": ").concat(proj.signals.data);
      }).join(', '), "}");
    } else {
      var _iterator2 = _createForOfIteratorHelper(bound),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var proj = _step2.value;
          var mapping = "".concat(stringValue(proj.field), ": ").concat(proj.signals.data);

          if (update.indexOf(mapping) < 0) {
            update = "".concat(update.substring(0, update.length - 1), ", ").concat(mapping, "}");
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      namedSg.update = update;
    }

    return signals.concat(bound.map(function (proj) {
      return {
        name: proj.signals.data
      };
    }));
  },
  signals: function signals(model, selCmpt, _signals) {
    // Nested signals need only push to top-level signals with multiview displays.
    if (model.parent && !isTopLevelLayer(model)) {
      var _iterator3 = _createForOfIteratorHelper(selCmpt.scales),
          _step3;

      try {
        var _loop = function _loop() {
          var proj = _step3.value;

          var signal = _signals.filter(function (s) {
            return s.name === proj.signals.data;
          })[0];

          signal.push = 'outer';
          delete signal.value;
          delete signal.update;
        };

        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    return _signals;
  }
};
export default scaleBindings;
export function domain(model, channel) {
  var scale = stringValue(model.scaleName(channel));
  return "domain(".concat(scale, ")");
}

function isTopLevelLayer(model) {
  var _a;

  return model.parent && isLayerModel(model.parent) && ((_a = !model.parent.parent) !== null && _a !== void 0 ? _a : isTopLevelLayer(model.parent.parent));
}